import { z } from "zod";

export const referenceTypeEnum = z.enum([
  "collection_and_session",
  "daily_quote",
  "deeplink_card",
  "hallow_plus_banner",
  "moodcheck",
  "prayer",
  "trivia",
  "trivia_leaderboard",
  "collection",
  "challenge",
  "suggested_routine",
  "prayer_goal",
  "daily",
  "chapter",
  "radio_station",
  "create_group",
  "invite_to_group",
  "alerts",
  "campaign",
  "community_challenge",
  "create_campaign_prompt",
  "create_campaign_prompt_v2_final",
  "community_collection",
  "text",
  "user_generated_text",
  "the_word",
  "text_first_content",
  "community_intention_prompt",
  "assignment",
  "community_hosted_collection",
]);

export type ReferenceType = z.infer<typeof referenceTypeEnum>;
